<script>
  import { WEEKLY_BLOCK_RANGE } from "../util/constants";

  const breakers = new Map();
  breakers.set(0, 0);
  breakers.set(4, 1);
  breakers.set(8, 2);
  breakers.set(12, 3);
  breakers.set(16, "top");

  export let index = null;

  let data = breakers.get(index);
  $: data = breakers.get(index);

  function getBlockRange(index) {
    const a = WEEKLY_BLOCK_RANGE[index];
    let b =
      index <= WEEKLY_BLOCK_RANGE.length - 1
        ? WEEKLY_BLOCK_RANGE[index + 1]
        : null;
    if (b == null) {
      b = "(END OF CROWDFUND)";
    }
    return `BLOCK NUMBER ≥ ${a}`;
  }
</script>

{#if data != null}
  <div class="breaker" class:firstBreaker={index === 0}>
    {#if data === "top"}
      <div>Reserved for Top Contributors</div>
    {:else}
      <div>Week {data + 1}</div>
      <div class="block-number">{getBlockRange(data)}</div>
    {/if}
  </div>
{/if}

<style>
  .breaker {
    flex-direction: row;
    /* background: red; */
    width: 100%;
    /* height: 32px; */
    /* background: pink; */
    border-bottom: 1px dashed black;
    margin-bottom: 10px;
    display: flex;
    padding-left: 0px;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 20px;
    text-transform: uppercase;
  }
  .block-number {
    font-size: 10px;
  }
  .firstBreaker {
    margin-top: 0;
  }
</style>
